import { escapeSvgAttr } from "./affineImageTriangle";

export interface ArtbrushReferenceImage {
    dataUrl: string;
    name: string;
    naturalWidth: number;
    naturalHeight: number;
    x: number;
    y: number;
    width: number;
    height: number;
}

/** Resize placement, keeping the image center fixed. */
export function resizeReferenceKeepingCenter(
    ref: Pick<ArtbrushReferenceImage, "x" | "y" | "width" | "height">,
    newWidth: number,
    newHeight: number,
): Pick<ArtbrushReferenceImage, "x" | "y" | "width" | "height"> {
    const width = Math.max(1, newWidth);
    const height = Math.max(1, newHeight);
    const cx = ref.x + ref.width / 2;
    const cy = ref.y + ref.height / 2;
    return {
        width,
        height,
        x: cx - width / 2,
        y: cy - height / 2,
    };
}

/** Place reference at origin, filling the canvas (1:1 with canvas units). */
export function referenceFullCanvasPlacement(
    canvasW: number,
    canvasH: number,
): Pick<ArtbrushReferenceImage, "x" | "y" | "width" | "height"> {
    return { x: 0, y: 0, width: canvasW, height: canvasH };
}

/** Fit image inside canvas (contain), centered. */
export function fitReferenceImageToCanvas(
    imgW: number,
    imgH: number,
    canvasW: number,
    canvasH: number,
): Pick<ArtbrushReferenceImage, "x" | "y" | "width" | "height"> {
    const scale = Math.min(canvasW / imgW, canvasH / imgH);
    const width = imgW * scale;
    const height = imgH * scale;
    return {
        x: (canvasW - width) / 2,
        y: (canvasH - height) / 2,
        width,
        height,
    };
}

export function buildReferenceImageMarkup(
    ref: ArtbrushReferenceImage,
    opacity: number,
): string {
    const o = Math.max(0, Math.min(1, opacity));
    return `<image href="${escapeSvgAttr(ref.dataUrl)}" x="${ref.x}" y="${ref.y}" width="${ref.width}" height="${ref.height}" opacity="${o}" preserveAspectRatio="none"/>`;
}
